var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30769 7.88571C5.30769 5.73969 7.06411 4 9.23077 4C11.3974 4 13.1538 5.73969 13.1538 7.88571C13.1538 10.0317 11.3974 11.7714 9.23077 11.7714C7.06411 11.7714 5.30769 10.0317 5.30769 7.88571Z",
    fill: "#0E9AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75123 13.5261L6.91563 13.5001C8.44935 13.2577 10.0122 13.2577 11.5459 13.5001L11.7103 13.5261C13.8714 13.8677 15.4615 15.714 15.4615 17.8816C15.4615 19.0516 14.504 20 13.3228 20H5.13874C3.95755 20 3 19.0516 3 17.8816C3 15.714 4.59016 13.8677 6.75123 13.5261Z",
    fill: "#0E9AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7692 4C14.3869 4 14.0769 4.307 14.0769 4.68571C14.0769 5.06442 14.3869 5.37143 14.7692 5.37143C16.1712 5.37143 17.3077 6.49711 17.3077 7.88571C17.3077 9.27432 16.1712 10.4 14.7692 10.4C14.3869 10.4 14.0769 10.707 14.0769 11.0857C14.0769 11.4644 14.3869 11.7714 14.7692 11.7714C16.9359 11.7714 18.6923 10.0317 18.6923 7.88571C18.6923 5.73969 16.9359 4 14.7692 4Z",
    fill: "#0E9AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9149 13.4916C15.5326 13.4916 15.2226 13.7986 15.2226 14.1773C15.2226 14.556 15.5326 14.863 15.9149 14.863H16.8086C16.8829 14.863 16.9573 14.8688 17.0306 14.8804C18.5197 15.1158 19.6154 16.388 19.6154 17.8816C19.6154 18.2942 19.2778 18.6286 18.8613 18.6286H16.9753C16.5929 18.6286 16.283 18.9356 16.283 19.3143C16.283 19.693 16.5929 20 16.9753 20H18.8613C20.0425 20 21 19.0516 21 17.8816C21 15.714 19.4098 13.8677 17.2488 13.5261C17.1032 13.5031 16.9559 13.4916 16.8086 13.4916H15.9149Z",
    fill: "#0E9AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIconFilled);
export default __webpack_public_path__ + "static/media/contactsIconFilled.f28a7234f83507221913e0d9fe9f1fe5.svg";
export { ForwardRef as ReactComponent };